module.exports = __webpack_public_path__ + "static/media/pencil.04b741e1.svg";